import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-service-page">
      <Header />
      
      <main className="pt-[75px] md:pt-[83px] pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-navy hover:text-gold mb-8 transition-colors">
            <ChevronLeft size={20} />
            <span>Back to Home</span>
          </Link>
          
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-navy mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">
              <strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
            
            <p className="text-slate-600 mb-6">
              Welcome to WMJ Enterprise Services LLC. By accessing our website and using our services, 
              you agree to be bound by these Terms of Service. Please read them carefully.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">1. Services</h2>
            <p className="text-slate-600 mb-6">
              WMJ Enterprise Services LLC provides tax preparation, tax planning, and financial consulting 
              services. Our services are provided to clients who engage us directly and provide the necessary 
              information and documentation.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">2. Client Responsibilities</h2>
            <p className="text-slate-600 mb-4">As a client, you agree to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Provide accurate, complete, and truthful information</li>
              <li>Supply all necessary tax documents and records in a timely manner</li>
              <li>Review and approve all tax returns before filing</li>
              <li>Pay all fees for services rendered</li>
              <li>Notify us of any changes to your information</li>
            </ul>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">3. Professional Standards</h2>
            <p className="text-slate-600 mb-6">
              We adhere to the professional standards set forth by the IRS and relevant state tax authorities. 
              Our tax professionals maintain the necessary credentials and continuing education requirements 
              to provide quality services.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">4. Fees and Payment</h2>
            <p className="text-slate-600 mb-6">
              Fees for our services will be communicated before work begins. Payment is due upon completion 
              of services unless otherwise agreed in writing. We accept various payment methods including 
              credit cards, checks, and electronic transfers.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">5. Limitation of Liability</h2>
            <p className="text-slate-600 mb-6">
              While we strive to provide accurate and complete tax preparation services, WMJ Enterprise 
              Services LLC's liability is limited to the fees paid for services. We are not responsible 
              for penalties or interest resulting from information provided by the client that is inaccurate 
              or incomplete.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">6. Confidentiality</h2>
            <p className="text-slate-600 mb-6">
              We maintain strict confidentiality of all client information in accordance with professional 
              standards and applicable laws. We will not disclose your information to third parties without 
              your consent, except as required by law.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">7. IRS Circular 230 Disclosure</h2>
            <div className="bg-slate-50 p-6 rounded-lg mb-6 border-l-4 border-gold">
              <p className="text-slate-600 text-sm">
                To ensure compliance with requirements imposed by the IRS, we inform you that any U.S. 
                federal tax advice contained in this communication (including any attachments) is not 
                intended or written to be used, and cannot be used, for the purpose of (i) avoiding 
                penalties under the Internal Revenue Code or (ii) promoting, marketing or recommending 
                to another party any transaction or matter addressed herein.
              </p>
            </div>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">8. Intellectual Property</h2>
            <p className="text-slate-600 mb-6">
              All content on this website, including text, graphics, logos, and software, is the property 
              of WMJ Enterprise Services LLC and is protected by copyright and trademark laws.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">9. Termination</h2>
            <p className="text-slate-600 mb-6">
              Either party may terminate the client relationship at any time. Upon termination, the client 
              remains responsible for payment of services rendered up to the date of termination.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">10. Governing Law</h2>
            <p className="text-slate-600 mb-6">
              These Terms of Service shall be governed by and construed in accordance with the laws of 
              the state in which WMJ Enterprise Services LLC is registered, without regard to its conflict 
              of law provisions.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">11. Changes to Terms</h2>
            <p className="text-slate-600 mb-6">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective 
              immediately upon posting to the website. Your continued use of our services constitutes 
              acceptance of the modified terms.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">12. Contact Information</h2>
            <p className="text-slate-600 mb-4">
              For questions regarding these Terms of Service, please contact us:
            </p>
            <div className="bg-slate-50 p-6 rounded-lg mb-6">
              <p className="text-slate-700 font-medium">WMJ Enterprise Services LLC</p>
              <p className="text-slate-600">Email: info@wmjenterpriseservices.com</p>
              <p className="text-slate-600">Phone: (901) 401-3054</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
